import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import '../App.css'

function Home() {
  const location = useLocation();
  const params = useParams();
  const splat = params['*'];

  useEffect(() => {
    const pathFromParams = splat ? `/${splat}` : null;
    const pathFromLocation = location?.pathname ?? window.location.pathname;
    const search = location?.search ?? window.location.search;
    let hash = location?.hash ?? window.location.hash;

    // Se ainda houver hash com caminho, remover o # e adicionar ao path
    let additionalPath = '';
    if (hash && hash.startsWith('#/')) {
      additionalPath = hash.substring(1); // Remove o # e usa como path adicional
      hash = ''; // Limpa o hash
    }

    const finalPath = pathFromParams && pathFromLocation === '/' ? pathFromParams : pathFromLocation;
    const fullPath = `${finalPath}${additionalPath}${search}${hash}`;
    const xappaAppUrl = `https://app.xappa.app${fullPath}`;

    setTimeout(() => {
      window.location.replace(xappaAppUrl);
    }, 1500);
  }, [location, splat]);

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.spinner}></div>
        <h2 style={styles.title}>Redirecionando para o app...</h2>
        <p style={styles.subtitle}>Por favor, aguarde um momento</p>
      </div>
    </div>
  )
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", sans-serif',
  } as React.CSSProperties,
  content: {
    textAlign: 'center' as const,
    color: 'black',
  },
  spinner: {
    width: '50px',
    height: '50px',
    margin: '0 auto 30px',
    border: '4px solid rgba(0, 0, 0, 0.3)',
    borderTop: '4px solid black',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  } as React.CSSProperties,
  title: {
    fontSize: '28px',
    fontWeight: '600',
    margin: '0 0 10px 0',
    letterSpacing: '0.5px',
  } as React.CSSProperties,
  subtitle: {
    fontSize: '14px',
    opacity: 0.9,
    margin: '0',
    fontWeight: '300',
  } as React.CSSProperties,
}

export default Home
